import { rem } from 'polished';
import styled from 'styled-components/macro';

export const StyledToolbar = styled.div`
  display: flex;
  align-items: center;
  gap: ${rem('12px')};
`;

export const StyledWrapper = styled.header`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${rem('72px')};
  border-bottom: 1px solid ${({ theme }) => theme.colors.cross.silverFox};
`;

export const StyledProfileButton = styled.button`
  display: inline-flex;
  flex-direction: row;
  align-items: center;
  gap: ${rem('8px')};
  appearance: none;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.cross.grayson};
  font-size: ${rem('14px')};
  font-weight: 700;
  text-transform: uppercase;
  background-color: transparent;
  border: none;

  > span {
    @media screen and (max-width: ${({ theme }) => theme.breakpoints.l}) {
      display: none;
    }
  }

  svg {
    width: ${rem('16px')};
    height: ${rem('16px')};

    path {
      fill: ${({ theme }) => theme.colors.cross.black};
    }
  }

  &:hover {
    color: ${({ theme }) => theme.colors.cross.black};

    svg path {
      fill: ${({ theme }) => theme.colors.cross.black};
    }
  }
`;
